(ns frontend.telemetry
  "Helpers for capturing custom browser telemetry, which is set to honeycomb.
     See docs here: https://docs.honeycomb.io/send-data/javascript-browser/honeycomb-distribution"
  (:require ["@opentelemetry/api" :as otel-api]
            [frontend.util]
            [re-frame.core :as rf]
            [taoensso.timbre :as timbre]))

(defonce *main-tracer-ref (atom nil))

(defn init-tracer! []
  (when-not @*main-tracer-ref
    (when-let [^js otel-trace otel-api/trace]
      (reset! *main-tracer-ref (.getTracer otel-trace "frontend-main")))))

;; The following are for reporting custom spans whose start
;; and end occur in arbitrary places in the code.
;; We use an atom to track the spans by name.
;; This can be used for tracking the duration between particular events, etc.

(defonce *span-map (atom {}))

(defn get-tracer []
  (or @*main-tracer-ref
      (timbre/error "browser telemetry tracer not initialized.")))

(defn span-key->span-name
  "Converts keyword to a span name string.
   Preserves namespace in the string."
  [span-key]
  (str span-key))

(defn start-span! [span-key attributes]
  (when-let [^js tracer (get-tracer)]
    (let [span-name (span-key->span-name span-key)
          span (.startSpan tracer span-name)]
      (when attributes
        (let [attribute-json (frontend.util/attribute-map->js-attributes attributes)]
          (.setAttributes span attribute-json)))
      (swap! *span-map assoc span-key span))))

(defn end-span! [span-key]
  (when-let [^js span (get @*span-map span-key)]
    (.end span)
    (swap! *span-map dissoc span-key)))

(rf/reg-fx :frontend.telemetry/start-span!
  (fn [[span-key attributes]]
    (start-span! span-key attributes)))

(rf/reg-fx :frontend.telemetry/end-span!
  (fn [[span-key]]
    (end-span! span-key)))
